import { IPostNewsLetterParams, NewsletterRepository } from "@/repositories/newsletter.repository"

export const NewsletterService = {
  Post: (params: IPostNewsLetterParams) => NewsletterRepository.Post(params),
}
